import { notification } from "antd";
import { get, isEmpty, noop } from "lodash";
import { useTranslation } from "react-i18next";
import { useLazyQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";

const useStaticDocumentDownload = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const [fetchFile] = useLazyQuery(graphql.queries.STATIC_DOCUMENT_FILE, {
    fetchPolicy: "network-only",
    onError: noop,
  });

  return async (document, version) => {
    const url = await fetchFile({
      variables: { where: { id: document.id }, version },
    })
      .then((result) => get(result, "data.staticDocumentFile"))
      .catch(() => null);
    if (isEmpty(url)) {
      notification.error({ message: t("STATIC.DOWNLOAD_FAILED") });
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };
};

export default useStaticDocumentDownload;
